import { onAuthStateChanged, type User } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { auth } from '@/firebase/init';
import { Navbar } from './Navbar';
import { NavbarLayout } from './NavbarLayout';

export function AuthFlowNavbar() {
  const [user, setUser] = useState<User | null>(() => auth.currentUser);

  useEffect(() => onAuthStateChanged(auth, setUser), []);

  if (user) {
    return <Navbar invitationsAmount={0} shouldShowSubscriptionsLink={false} />;
  }
  return <NavbarLayout />;
}
